"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.MaxLengthText = function (_a) {
    var text = _a.children, maxLength = _a.maxLength, expanded = _a.expanded, showLessText = _a.showLessText, showMoreText = _a.showMoreText;
    var _b = react_1.useState(expanded || false), isExpanded = _b[0], setIsExpanded = _b[1];
    var maybeTruncatedText = ellipsize(text, maxLength);
    var isTruncated = maybeTruncatedText !== text;
    var toggle = isTruncated ? (react_1.default.createElement(react_1.default.Fragment, null,
        ' ',
        react_1.default.createElement("a", { onClick: function () { return setIsExpanded(!isExpanded); } }, isExpanded ? showLessText || 'less' : showMoreText || 'more'))) : null;
    return (react_1.default.createElement("span", null,
        isExpanded ? text : maybeTruncatedText,
        toggle));
};
var PATTERN_NON_WORD_CHAR = /\W/;
var PATTERN_WORD_CHAR = /\w/;
var ELLIPSIS = '…';
/**
 * If the provided string exceeds the provided max length, returns a truncated
 * string with an appended ellipsis. The method avoids breaking mid-word.
 *
 * @param {string} text The text to truncate.
 * @param {number} maxLengthgth The maximum number of characters to show.
 *
 * @return {string} the truncated text, or full text if it's shorter than the provided maxLength.
 */
function ellipsize(text, maxLength) {
    if (maxLength === void 0) { maxLength = 60; }
    if (typeof maxLength !== 'number') {
        throw new Error('maxLength must be a number');
    }
    maxLength -= ELLIPSIS.length;
    if (text && text.length > maxLength) {
        while (maxLength > 1 &&
            (!PATTERN_WORD_CHAR.test(text[maxLength - 1]) ||
                !PATTERN_NON_WORD_CHAR.test(text[maxLength]))) {
            maxLength -= 1;
        }
        if (maxLength === 1) {
            return text;
        }
        else {
            return text.substring(0, maxLength) + ELLIPSIS;
        }
    }
    else {
        return text;
    }
}
//# sourceMappingURL=MaxLengthText.js.map